import React from 'react';
import { Box, Typography, TextField, IconButton, Button, InputAdornment } from '@mui/material';
import { Add as AddIcon, Delete as DeleteIcon } from '@mui/icons-material';
import VariablePicker from '../../VariablePicker';
import { generateId } from '../../../../utils/idGeneration';
import { FlowComponent } from '../../../../flow-core/FlowComponent';
import { SwitchCore } from '../../../../flow-core/components/SwitchCore';

export const SwitchComponent = new FlowComponent({
  ...SwitchCore,
  renderPreview(_properties) {
    return null;
  },
  renderPropertyEditor(properties, onChange, context) {
    const cases = properties.cases || [];

    const updateCase = (id, field, val) => {
      onChange('cases', cases.map(c => c.id === id ? { ...c, [field]: val } : c));
    };

    const addCase = () => {
      onChange('cases', [...cases, { id: generateId(), caseValue: '', children: [] }]);
    };

    const removeCase = (id) => {
      onChange('cases', cases.filter(c => c.id !== id));
    };

    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Box>
          <Typography variant="subtitle2" gutterBottom>Switch on</Typography>
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
            A variable reference whose value is matched against each case. Updates reactively as the user interacts.
          </Typography>
          <TextField
            size="small"
            fullWidth
            placeholder="${form.field}"
            value={properties._switchValue || ''}
            onChange={e => onChange('_switchValue', e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <VariablePicker
                    screens={context?.screens}
                    currentScreenId={context?.currentScreenId}
                    onInsert={ref => onChange('_switchValue', ref)}
                  />
                </InputAdornment>
              ),
            }}
          />
        </Box>

        <Box>
          <Typography variant="subtitle2" gutterBottom>Cases</Typography>
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
            Add a case for each value to match. Drag components into each case branch on the canvas.
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {cases.map(c => (
              <Box key={c.id} sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                <TextField
                  size="small"
                  fullWidth
                  placeholder="match value (e.g. pro)"
                  value={c.caseValue}
                  onChange={e => updateCase(c.id, 'caseValue', e.target.value)}
                />
                <IconButton
                  size="small"
                  onClick={() => removeCase(c.id)}
                  disabled={cases.length === 1}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Box>
            ))}
          </Box>
          <Button
            size="small"
            startIcon={<AddIcon />}
            onClick={addCase}
            sx={{ mt: 1 }}
          >
            Add case
          </Button>
        </Box>
      </Box>
    );
  },
});
